import React from 'react';
import { motion } from 'framer-motion';
import { BsBriefcaseFill } from 'react-icons/bs';

const experiences = [
  {
    role: "Mobile Software Engineer",
    company: "Miva, Nigeria",
    date: "Feb 2025 - Present",
    description: "Leading the cross-platform mobile strategy using Kotlin Multiplatform (KMP) to unify business logic for a highly scalable edutech application. Mentoring junior developers in modern mobile architecture."
  },
  {
    role: "Mobile Software Engineer",
    company: "Opportunity Global Fund, Cayman Islands",
    date: "Apr 2021 - Jun 2025",
    description: "Built and shipped Opportunik's cross-platform investment app (Flutter/Dart) connecting investors to curated global funds. Achieved 10K+ Android installs and 5.0/5 App Store rating."
  },
  {
    role: "Lead Mobile Developer",
    company: "Ladda, Lagos, Nigeria",
    date: "Jan 2020 - Dec 2021",
    description: "Led the team that built Ladda's cross-platform savings & investing app. Delivered end-to-end mobile architecture for goal-based saving and integrated SEC-regulated asset managers."
  },
  {
    role: "Android Developer",
    company: "Dryva, Lagos, Nigeria",
    date: "Feb 2019 - Dec 2019",
    description: "Developed an end-to-end supply chain management solution. Implemented real-time tracking systems using Google Maps SDK and Firebase notifications."
  },
  {
    role: "Android Developer",
    company: "Jiggle, Uyo, Nigeria",
    date: "Jan 2017 - Jan 2019",
    description: "Developed live Android applications with REST APIs. Managed user wallet and payment flows, migrating architectures from MVI to MVVM with Dagger and RxJava."
  }
];

const WorkedCompanies = () => {
  return (
    <section id='experience' className='py-24 bg-[#040811] relative overflow-hidden'>
      {/* Background aesthetics */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full filter blur-[100px] pointer-events-none"></div>
      
      <div className='max-w-4xl mx-auto px-6 lg:px-8 relative z-10'>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className='text-3xl md:text-5xl font-bold text-white mb-4'>Experience</h2>
          <div className="h-1 w-20 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
        </motion.div>
        
        <div className="relative border-l border-slate-700/50 space-y-12 ml-3 md:ml-6">
          {experiences.map((exp, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative pl-8 md:pl-12"
            >
              <div className="absolute w-10 h-10 bg-slate-900 border border-slate-700 rounded-full flex items-center justify-center -left-[20px] top-1 shadow-lg z-10">
                <BsBriefcaseFill className="text-primary text-sm" />
              </div>
              
              <div className="bg-slate-800/30 border border-slate-700/50 hover:border-primary/50 transition-colors p-6 rounded-2xl backdrop-blur-sm group">
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-2">
                  <div>
                    <h3 className="text-xl font-bold text-white group-hover:text-primary transition-colors">{exp.role}</h3>
                    <h4 className="text-lg text-secondary font-medium">{exp.company}</h4>
                  </div>
                  <span className="inline-block px-4 py-1.5 bg-slate-800 text-slate-300 text-sm font-medium rounded-full border border-slate-700 whitespace-nowrap">
                    {exp.date}
                  </span>
                </div>
                <p className="text-slate-400 leading-relaxed text-sm md:text-base">
                  {exp.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WorkedCompanies;
